import { reduceValidationResults } from '../validators';
import { t } from '../../../utils/translate';

export const resetRowValids = state => ({
  ...state,
  rowValids: state.rows.map(() => true),
});

export const minMarkers = min => state => {
  const rowValids = state.rows.map(row => row.keys.length >= min);
  const areAllRowsValid = rowValids.every(v => v === true);
  const isForgiven = state.rows.some(row => !row.isTouched);
  const isValid = areAllRowsValid || isForgiven;
  const errorMessages = isValid ? null : [t('heat_map_min')];
  return reduceValidationResults(state, {
    errorMessages,
    isValid,
    rowValids: state.rowValids.map((v, i) => v && rowValids[i]),
  });
};

// export const maxMarkers = (max) => (state) => {
//   const rowValids = state.rows.map(row => row.keys.length <= max);
//   const areAllRowsValid = rowValids.every(v => v === true);
//   const isForgiven = state.rows.some(row => !row.isTouched);
//   const isValid = areAllRowsValid || isForgiven;
//   const errorMessages = isValid ? null : [ t('heat_map_max') ];
//   return reduceValidationResults(state, {
//     errorMessages,
//     isValid,
//     rowValids: state.rowValids.map((v, i) => v && rowValids[i]),
//   })
// }

export const requiredSticky = shouldRun => state => {
  if (!shouldRun) return state;

  const keys = state.rows.reduce((all, row) => all.concat(row.keys), []);
  const markerValids = keys.reduce(
    (valids, key) => ({
      ...valids,
      [key]: !!state.notes[key] && !!state.notes[key].trim().length,
    }),
    {}
  );
  const rowValids = state.rows.map(row =>
    row.keys.every(key => markerValids[key])
  );
  const isAllFilled = rowValids.every(v => v === true);

  const isForgiven = state.rows.some(row => !row.isTouched);
  const isValid = isAllFilled || isForgiven;
  const errorMessages = isValid ? null : [t('sticky_note_required')];
  return reduceValidationResults(state, {
    errorMessages,
    isValid,
    markerValids,
    rowValids: state.rowValids.map((v, i) => v && rowValids[i]),
  });
};

export const checkCompletion = state => {
  const { isValid, rows } = state;
  const isAnyTouched = rows.some(r => r.isTouched);
  const isAllTouched = rows.every(r => r.isTouched);
  return {
    ...state,
    completionStatus: isAnyTouched
      ? isValid && isAllTouched ? 'done' : 'in-progress'
      : 'waiting',
  };
};
